import React, { useEffect, useContext } from 'react'
import { useParams, useHistory } from 'react-router-dom'
import { makeStyles } from '@material-ui/core/styles'
import {
  Paper,
  TableContainer,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  Avatar,
  Typography,
  IconButton,
  Chip,
} from '@material-ui/core'
import ArrowBackIcon from '@material-ui/icons/ArrowBack'
import { GlobalContext } from '../../hooks/reducer'
import { actions as adminActions } from '../../hooks/useAdminReducer'
import MainTemplate from '../templates/MainTemplate'
import { actions as loginActions } from '../../hooks/useLoginUserReducer'

const useStyles = makeStyles((theme) => ({
  root: { width: '100%' },
  header: { display: 'flex', alignItems: 'center', marginBottom: theme.spacing(2) },
  backButton: { marginRight: theme.spacing(1) },
  title: { flexGrow: 1 },
  table: { minWidth: 650 },
  avatar: { width: theme.spacing(4), height: theme.spacing(4) },
  adminChip: { marginLeft: theme.spacing(1) },
}))

const CompanyMembers = () => {
  const classes = useStyles()
  const history = useHistory()
  const { companyId } = useParams()
  const { state: { loginUser, admin }, dispatch } = useContext(GlobalContext)
  const { users = [], currentCompany } = admin

  useEffect(() => {
    if (!loginUser.isLogin) {
      loginActions.loginCheck(dispatch, history)
      return
    }

    // companyId ごとの情報取得
    dispatch({ type: 'CLEAR_CURRENT_COMPANY' })
    dispatch({ type: 'CLEAR_USERS' })
    adminActions.getUsersByCompanyId(dispatch, companyId)

    return () => {
      dispatch({ type: 'CLEAR_CURRENT_COMPANY' })
      dispatch({ type: 'CLEAR_USERS' })
    }
  }, [loginUser.isLogin, companyId, dispatch, history])

  const members = users

  return (
    <MainTemplate>
      <div className={classes.root}>
        <div className={classes.header}>
          <IconButton
            edge="start"
            className={classes.backButton}
            onClick={() => history.goBack()}
          >
            <ArrowBackIcon />
          </IconButton>
          <Typography variant="h6" className={classes.title}>
            {currentCompany ? `${currentCompany.name} のメンバー一覧` : 'メンバー一覧'}
          </Typography>
        </div>

        <Paper>
          <TableContainer>
            <Table className={classes.table}>
              <TableHead>
                <TableRow>
                  <TableCell>アバター</TableCell>
                  <TableCell>名前</TableCell>
                  <TableCell>メール</TableCell>
                  <TableCell>管理者</TableCell>
                  <TableCell>登録日</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {members.length > 0 ? (
                  members.map((user) => (
                    <TableRow key={user.userId} hover>
                      <TableCell>
                        <Avatar
                          src={user.imageUrl}
                          alt={user.name}
                          className={classes.avatar}
                        />
                      </TableCell>
                      <TableCell>{user.name}</TableCell>
                      <TableCell>{user.email}</TableCell>
                      <TableCell>
                        {user.admin ? (
                          <Chip
                            label="管理者"
                            size="small"
                            color="primary"
                            style={{color: "white"}}
                            className={classes.adminChip}
                          />
                        ) : (
                          <Typography>—</Typography>
                        )}
                      </TableCell>
                      <TableCell>{new Date(user.createAt).toLocaleDateString()}</TableCell>
                    </TableRow>
                  ))
                ) : (
                  <TableRow>
                    <TableCell colSpan={5} align="center">
                      メンバーが見つかりません。
                    </TableCell>
                  </TableRow>
                )}
              </TableBody>
            </Table>
          </TableContainer>
        </Paper>
      </div>
    </MainTemplate>
  )
}

export default CompanyMembers
